module.exports = __webpack_public_path__ + "img/step1-1.c8fd1b13.png";